import React, { FC } from "react";
import TextLink from "Shared/components/text-link";
import { useTranslation } from "Shared/util/custom-hooks";

export const OpenBankingPrivacyPolicy: FC = () => {
    const t = useTranslation(
        (x) => x.edit_payment_information.open_banking_privacy_policy,
    );

    return (
        <div>
            <p>{t.paragraphOne}</p>
            <p>
                {t.paragraphTwo}{" "}
                <TextLink
                    link="https://www.openpayments.io/legal"
                    text={t.linkText}
                />
            </p>
        </div>
    );
};
